import { ActionType, ErrorCode, userStr } from "../constants";
import { messageDtStr } from "../utils/utils";

const initialState = {
  input: "",
  // users: {},
  history: [],
  recipient: null, // from users
  fullyLoaded: true,

  numLocalMessages: 0,
  allChats: null,
  recipientProfilePics: {},
  numUnread: 0,
};
export default (state = initialState, action) => {
  try {
    switch (action.type) {
      case ActionType.setNumUnread:
        return {
          ...state,
          numUnread: action.payload.numUnread,
        };
      case ActionType.setRecipientProfilePic:
        console.log("setting recipient profile pic", action.payload);
        return {
          ...state,
          recipientProfilePics: {
            ...state.recipientProfilePics,
            // profilePic can be null, or {url, scale}
            [action.payload.userId]: action.payload.profilePic,
          },
        };
      case ActionType.setChatInput:
        return {
          ...state,
          input: action.payload,
        };
      case ActionType.setAllChats:
        return {
          ...state,
          allChats: action.payload,
        };
      case ActionType.updateAllChats:
        const newChatUserIds = action.payload.map(
          (chat) => chat.recipient.userId
        );
        const chatsWithoutUpdate = state.allChats.filter(
          (chat) => !newChatUserIds.includes(chat.recipient.userId)
        );
        return {
          ...state,
          allChats: [...chatsWithoutUpdate, ...action.payload],
        };
      case ActionType.selectChat:
        console.log("selecting chat", action.payload);
        return {
          ...state,
          history: action.payload.history,
          recipient: action.payload.recipient,
          fullyLoaded: action.payload.fullyLoaded,
        };
      case ActionType.appendChatHistory:
        // appending to chat history, entirely client side
        return {
          ...state,
          numLocalMessages: state.numLocalMessages + 1,
          history: [...state.history, action.payload],
          allChats: state.allChats.map((chat) => {
            if (chat.recipient.userId === state.recipient.userId) {
              return {
                ...chat,
                history: [...chat.history, action.payload],
              };
            }
            return chat;
          }),
        };
      case ActionType.retryLocalMessage:
        return {
          ...state,
          history: state.history.map((message) => {
            if (message.localId === action.payload.localId) {
              return {
                ...message,
                waitingForServer: true,
                failed: false,
                dt: messageDtStr(),
              };
            }
            return message;
          }),
          allChats: state.allChats.map((chat) => {
            if (chat.recipient.userId === action.payload.receipientId) {
              return {
                ...chat,
                history: chat.history.map((message) => {
                  if (message.localId === action.payload.localId) {
                    return {
                      ...message,
                      waitingForServer: true,
                      failed: false,
                      dt: messageDtStr(),
                    };
                  }
                  return message;
                }),
              };
            }
            return chat;
          }),
        };
      case ActionType.successLocalMessage:
        return {
          ...state,
          history: state.history.map((message) => {
            if (message.localId === action.payload.localId) {
              return {
                ...message,
                waitingForServer: false,
                serverId: action.payload.serverId,
                success: true,
                failed: false,
              };
            }
            return message;
          }),
          allChats: state.allChats.map((chat) => {
            if (chat.recipient.userId === action.payload.receipientId) {
              return {
                ...chat,
                history: chat.history.map((message) => {
                  if (message.localId === action.payload.localId) {
                    return {
                      ...message,
                      waitingForServer: false,
                      serverId: action.payload.serverId,
                      success: true,
                      failed: false,
                    };
                  }
                  return message;
                }),
              };
            }
            return chat;
          }),
        };
      case ActionType.failLocalMessage:
        return {
          ...state,
          history: state.history.map((message) => {
            if (message.localId === action.payload.localId) {
              return {
                ...message,
                waitingForServer: false,
                failed: true,
              };
            }
            return message;
          }),
          allChats: state.allChats.map((chat) => {
            if (chat.recipient.userId === action.payload.receipientId) {
              return {
                ...chat,
                history: chat.history.map((message) => {
                  if (message.localId === action.payload.localId) {
                    return {
                      ...message,
                      waitingForServer: false,
                      failed: true,
                    };
                  }
                  return message;
                }),
              };
            }
            return chat;
          }),
        };
      case ActionType.setFullChat:
        console.log("setting full chat", action.payload);
        const allChats = state.allChats.map((chat) => {
          if (chat.recipient.userId === action.payload.recipient.userId) {
            return action.payload;
          } else {
            return chat;
          }
        });
        if (
          state.recipient &&
          state.recipient.userId === action.payload.recipient.userId
        ) {
          return {
            ...state,
            history: action.payload.history,
            recipient: action.payload.recipient,
            fullyLoaded: true,
            allChats,
          };
        } else {
          return {
            ...state,
            allChats,
          };
        }
      default:
        return state;
    }
  } catch (e) {
    console.log("messagesReducer error:", e);
  }
};
